/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { AskUserQuestionsContent } from "./AskUserQuestionsContent";
import type { AttachmentContent } from "./AttachmentContent";
import type { CarePlanContentOutput } from "./CarePlanContentOutput";
import type { ClinicRequestContent } from "./ClinicRequestContent";
import type { CommentableContentContent } from "./CommentableContentContent";
import type { CuraiRedirectContent } from "./CuraiRedirectContent";
import type { DocumentPreviewContent } from "./DocumentPreviewContent";
import type { HomeCarePlanContent } from "./HomeCarePlanContent";
import type { LocationInputContent } from "./LocationInputContent";
import type { MedicationHistoryRequestContent } from "./MedicationHistoryRequestContent";
import type { OutputContentList } from "./OutputContentList";
import type { OutreachContent } from "./OutreachContent";
import type { PreClinicStepsContent } from "./PreClinicStepsContent";
import type { RXInputContent } from "./RXInputContent";
import type { RXQuestionContent } from "./RXQuestionContent";
import type { RxFlowConsent } from "./RxFlowConsent";
import type { SOAPNoteContent } from "./SOAPNoteContent";
import type { TriageSummaryContent } from "./TriageSummaryContent";
import type { UpsellContent } from "./UpsellContent";
import type { UserInputContentList } from "./UserInputContentList";
import type { UserInputFilePart } from "./UserInputFilePart";
import type { UserInputFilePartWithUrl } from "./UserInputFilePartWithUrl";
import type { UserInputImagePart } from "./UserInputImagePart";
import type { UserInputImagePartWithUrl } from "./UserInputImagePartWithUrl";
import type { UserInputTextPart } from "./UserInputTextPart";
import type { ZocdocBookingContent } from "./ZocdocBookingContent";

export interface EventModel {
  id: string;
  conversation_id: string;
  clinic_request_id?: string | null;
  origin_clinic_request_id?: string | null;
  user_id: string;
  turn_id?: string | null;
  role?: string | null;
  type: string | null;
  content:
    | string
    | PreClinicStepsContent
    | TriageSummaryContent
    | HomeCarePlanContent
    | SOAPNoteContent
    | CarePlanContentOutput
    | AttachmentContent
    | OutreachContent
    | CuraiRedirectContent
    | ClinicRequestContent
    | UserInputContentList
    | OutputContentList
    | RxFlowConsent
    | RXQuestionContent
    | RXInputContent
    | LocationInputContent
    | UpsellContent
    | AskUserQuestionsContent
    | DocumentPreviewContent
    | CommentableContentContent
    | ZocdocBookingContent
    | MedicationHistoryRequestContent
    | (
        | UserInputTextPart
        | UserInputImagePart
        | UserInputImagePartWithUrl
        | UserInputFilePart
        | UserInputFilePartWithUrl
      )[]
    | null;
  feedback?: number;
  feedback_comment?: string | null;
  created_at?: string | null;
  sender_photo_url?: string | null;
  sender_full_name_with_title?: string | null;
  channel?: string | null;
}
